/**
 * Formattazione delle date nell'ora della societa.
 *
 * L'ora di una partita o di un allenamento e quella del campo, italiana, come
 * sul server e nel calendario: un telefono con un altro fuso, o con
 * l'orologio impostato male, non deve spostare ore e giorni. Tutte le viste
 * formattano da qui, e un test vieta formatter e getter locali altrove.
 */

import { FUSO_SOCIETA, dataLocale } from '@calcio/shared';

type Opzioni = Omit<Intl.DateTimeFormatOptions, 'timeZone'>;

/** Formatter di un istante, letto nell'ora italiana. */
export const formatoIstante = (opzioni: Opzioni): Intl.DateTimeFormat =>
  new Intl.DateTimeFormat('it-IT', { ...opzioni, timeZone: FUSO_SOCIETA });

/**
 * Formatter di una data di calendario senza ora, come "2026-09-23" letta a
 * mezzanotte UTC: in UTC il giorno resta quello scritto.
 */
export const formatoGiorno = (opzioni: Opzioni): Intl.DateTimeFormat =>
  new Intl.DateTimeFormat('it-IT', { ...opzioni, timeZone: 'UTC' });

/** La mezzanotte UTC di una data di calendario, da passare a `formatoGiorno`. */
export const giornoUtc = (data: string): Date => new Date(`${data}T00:00:00Z`);

/** Oggi nel giorno italiano, come "2026-09-17". */
export const oggi = (): string => dataLocale(new Date());
